import React, { useEffect, useState, Fragment } from 'react';
import {
  HomeMainPCListTooltip,
  HomeMainPCShortcut,
} from '@container/home/main/mainPC';
import { PRODUCT_COMP_CD } from '@common/constants';

const HOME_PC_COMP_CODE_INFOS = [
  {
    label: '전체',
    code: '',
    className: 'btn-a',
  },
  {
    label: '구.KB생명',
    code: PRODUCT_COMP_CD.kb,
    className: 'btn-k',
  },
  {
    label: '구.푸르덴셜',
    code: PRODUCT_COMP_CD.pr,
    className: 'btn-p',
  },
];

const HOME_PC_PRODUCT_INFOS = [
  {
    label: '종신',
    code: '1',
    products: [],
  },
  {
    label: '연금/저축',
    code: '2',
    products: [],
  },
  {
    label: '건강',
    code: '3',
    products: [],
  },
  {
    label: '정기',
    code: '4',
    products: [],
  },
  {
    label: '전체',
    code: '',
    products: [],
  },
];

// compCd별 상품 Icon 정보
const PRODUCT_ICON_INFOS = {
  '': 'ico-a',
  [PRODUCT_COMP_CD.kb]: 'ico-k',
  [PRODUCT_COMP_CD.pr]: 'ico-p',
};

const HomeMainPCList = () => {
  const { error: toastError } = $hooks.useToast();
  const { channelInfo } = $hooks.useUser();
  const { getMainLinkToken, searchProductPC } = $hooks.useApi();
  const { cdVal: channelCode } = channelInfo;

  // "compCd": ""  ==> 전체
  // "compCd": "2"  ==> KB생명
  // "compCd": "3"  ==> 푸르덴셜 생명
  const [selectedCompCd, setSelectedCompCd] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const currentProductTypeInfo = productTypes[tabIndex] || {};

  const handleChangeSearchTerm = ({ target }) => setSearchTerm(target.value);

  const selectCompCd = compCode => {
    if (compCode === selectedCompCd) setSelectedCompCd('');
    else setSelectedCompCd(compCode);
  };

  const fetchProducts = async () => {
    const todayDateString = $utils.formatBoardDate(new Date());
    const payload = {
      chnlCd: channelCode,
      calculateDate: todayDateString,
    };
    const response = await searchProductPC({ payload });

    // Product API 처리
    const isProductSuccess = $utils.checkApiSuccess(response);

    if (isProductSuccess) {
      const data = $utils.getApiData(response);
      const { productList, productTypeList } = data;

      const newProductTypeList = [
        ...productTypeList,
        {
          productType: '',
          productTypeName: '전체',
        },
      ];

      setProducts(productList);
      setProductTypes(newProductTypeList);

      // LP 채널 일 때는 전체 탭(마지막 탭)으로 설정
      const isLP = $utils.checkLP(channelInfo.cdVal);
      if (isLP) setTabIndex(newProductTypeList.length - 1);
    } else {
      toastError('상품을 가져오는데 실패하였습니다.');
    }
  };

  const filterProducts = () => {
    const newProductInfos = fp.cloneDeep(HOME_PC_PRODUCT_INFOS);
    const filteredProducts = products.filter(({ compCd, productName }) => {
      const isCompCodeProduct = !selectedCompCd || compCd === selectedCompCd;
      const isSearchTermProduct =
        !searchTerm.trim() ||
        productName?.toLowerCase().includes(searchTerm.toLowerCase());

      return isCompCodeProduct && isSearchTermProduct;
    });

    filteredProducts.forEach(product => {
      const { saleProdGrpCd } = product;
      const productInfoIndex = newProductInfos.findIndex(
        ({ code }) => code === saleProdGrpCd,
      );
      if (productInfoIndex < 0) return;

      const productInfo = newProductInfos[productInfoIndex];
      const products = productInfo.products || [];
      products.push(product);
      productInfo.products = products;
      newProductInfos[productInfoIndex] = productInfo;
    });

    setFilteredProducts(filteredProducts);
  };

  const getMainLinkUrlInfo = (linkType, token) => {
    const curexUrl = $utils.isUat
      ? // UAT 인경우
        $utils.isExternal
        ? `http://dcrxw.prudential.co.kr:456/main/login/login/index.cmd?token=${token}`
        : `http://ncurexdev.prudential.co.kr:9080/main/login/login/index.cmd?token=${token}`
      : $utils.isDevLocal
      ? // 개발인 경우
        $utils.isExternal
        ? `http://dcrxw.prudential.co.kr:456/main/login/login/index.cmd?token=${token}`
        : `http://ncurexdev.prudential.co.kr:9080/main/login/login/index.cmd?token=${token}`
      : // 개발이 아닌 경우
      $utils.isExternal
      ? `http://crxw.kblife.co.kr/main/login/login/index.cmd?token=${token}`
      : `http://curex1.prudential.co.kr/main/login/login/index.cmd?token=${token}`;

    const galipsUrl = $utils.isUat
      ? // UAT 인경우
        $utils.isExternal
        ? `https://dlipsweb.kblife.co.kr/scr/m/login?request=goLogin&token=${token}`
        : `http://lipsuat.prudential.co.kr/scr/m/login?request=goLogin&token=${token}`
      : $utils.isDevLocal
      ? // 개발인 경우
        $utils.isExternal
        ? `https://dlipsweb.kblife.co.kr/scr/m/login?request=goLogin&token=${token}`
        : `https://lipsdev.prudential.co.kr:444/scr/m/login?request=goLogin&token=${token}`
      : // 개발이 아닌 경우
      $utils.isExternal
      ? `https://lipsweb.kblife.co.kr/scr/m/login?request=goLogin&token=${token}`
      : `https://lips.prudential.co.kr/scr/m/login?request=goLogin&token=${token}`;

    const kbStarUrl = $utils.isUat
      ? // UAT 인경우
        $utils.isExternal
        ? `http://tsfa.kbli.co.kr/common/sfa.xp?method=main&token=${token}`
        : `http://tsfa.kbli.co.kr/common/sfa.xp?method=main&token=${token}`
      : $utils.isDevLocal
      ? // 개발인 경우
        $utils.isExternal
        ? `http://tsfa.kbli.co.kr/common/sfa.xp?method=main&token=${token}`
        : `http://tsfa.kbli.co.kr/common/sfa.xp?method=main&token=${token}`
      : // 개발이 아닌 경우
      $utils.isExternal
      ? `http://esfa.kbli.co.kr/common/sfa.xp?method=main&token=${token}`
      : `http://sfa.kbli.co.kr/common/sfa.xp?method=main&token=${token}`;

    const urlInfo = {
      curex: curexUrl,
      galips: galipsUrl,
      kbstar: kbStarUrl,
    };

    return urlInfo[linkType];
  };

  const openLink = async compCd => {
    try {
      const linkType =
        compCd === PRODUCT_COMP_CD.kb
          ? 'kbstar'
          : $utils.checkGA(channelCode)
          ? 'galips'
          : 'curex';

      const token = await $utils.getLinkToken(getMainLinkToken);
      if (!token) return toastError('링크 정보를 가져오는데 실패하였습니다.');

      const link = getMainLinkUrlInfo(linkType, token);
      if (link) $utils.openUrl(link);
      else toastError('해당 링크는 아직 정해지지 않았습니다.');
    } catch (error) {
      toastError('링크를 가져오는데 실패하였습니다.');
    }
  };

  useEffect(fetchProducts, []);
  useEffect(filterProducts, [selectedCompCd, products, searchTerm]);

  return (
    <>
      <div className="wide-con-wrap">
        <div className="tbl-header">
          <div className="productChoiceBtn">
            {HOME_PC_COMP_CODE_INFOS.map(({ label, code, className }) => (
              <button
                key={code}
                type="button"
                className={$classNames('btn-s', className, {
                  active: selectedCompCd === code,
                })}
                onClick={() => selectCompCd(code)}
              >
                {label}
              </button>
            ))}
          </div>

          <div className="right-area">
            <div className="sch-box">
              <div className="input-wrap inp-search">
                <div className="input-area">
                  <input
                    type="text"
                    className="input line1"
                    placeholder="상품명을 검색하세요."
                    value={searchTerm}
                    onChange={handleChangeSearchTerm}
                  />
                </div>

                {/* 검색 input에 focus 갈때 ico ico-del에 on class 추가 */}
                <button type="button" className="ico ico-del">
                  지우기
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="tab-wrap">
          <ul className="tab-nav tab-type2">
            {productTypes.map(({ productType, productTypeName }, index) => (
              <li
                key={productType}
                className={$classNames({ active: index === tabIndex })}
                onClick={() => setTabIndex(index)}
              >
                <span className="tab">{productTypeName}</span>
              </li>
            ))}
          </ul>

          {productTypes.map(({ productType }, index) => (
            <div
              key={productType}
              className={$classNames('tab-con custom-display-scroll', {
                active: index === tabIndex,
              })}
            >
              {/* 현재 Tab이 전체 / 전체가 아닌 경우로 구분 */}
              {currentProductTypeInfo?.productType === '' ? (
                <ProductListAll
                  products={filteredProducts}
                  productTypes={productTypes}
                  openLink={openLink}
                />
              ) : (
                <ProductList
                  products={filteredProducts}
                  productType={productType}
                  openLink={openLink}
                  isRecommend={productType === '0'}
                />
              )}
            </div>
          ))}
        </div>
      </div>

      <HomeMainPCShortcut openLink={openLink} />
    </>
  );
};

const ProductListAll = ({ products, productTypes, openLink }) => {
  return productTypes.map(({ productType, productTypeName }) =>
    // List가 전체(productType === '')인 경우 아무것도 노출 안함
    productType === '' ? (
      <Fragment key={`all-${productType}`} />
    ) : productType === '0' ? (
      <Fragment key={`all-${productType}`}>
        <p className="insu-pro-tit">{productTypeName}</p>
        <ProductList
          products={products}
          productType={productType}
          openLink={openLink}
        />
      </Fragment>
    ) : (
      // 전체 탭 상품 노출에서, 추천 상품 노출로 변경 되어 추천에 노출된 상품은 일반 리스트에서 제외
      <Fragment key={`all-${productType}`}>
        <p className="insu-pro-tit">{productTypeName}</p>
        <ProductList
          products={products.filter(
            product => product.isRecommendProduct !== 'Y',
          )}
          productType={productType}
          openLink={openLink}
        />
      </Fragment>
    ),
  );
};

const ProductList = ({ products, productType, openLink, isRecommend }) => {
  const getDisplayProducts = productType => {
    const isRecommend = productType === '0';

    // 추천 상품인 경우, isRecommendProduct === 'Y' 인 상품만 노출
    if (isRecommend) {
      return products.filter(product => product.isRecommendProduct === 'Y');
    } else {
      const isAll = productType === '';
      const displayProducts = products.filter(
        product => product.productType === productType,
      );

      // 전체 상품인 경우, isRecommendProduct !== 'Y' 인 상품 중에서만 노출
      if (isAll)
        return displayProducts.filter(
          product => product.isRecommendProduct !== 'Y',
        );
      return displayProducts;
    }
  };

  const displayProducts = getDisplayProducts(productType);

  return (
    <ul className={$classNames('insu-pro-list', { col2: isRecommend })}>
      {displayProducts.map(({ compCd, productCode, productName, child }) => (
        <li key={productCode}>
          <span>
            <div className="icon_box pdl-30">
              <span
                className={$classNames('ico2', PRODUCT_ICON_INFOS[compCd])}
              />
            </div>
            {productName}

            <button
              type="button"
              className="btn-s blue side-r"
              onClick={() => openLink(compCd)}
            >
              이동 &gt;
            </button>

            {/* @NOTE: '선택+' 버튼 삭제 요청으로, Tooltip 주석 처리 */}
            {/* {child && (
              <HomeMainPCListTooltip products={child} openLink={openLink} />
            )} */}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default HomeMainPCList;
